import React, {createContext, useState} from 'react';
import {getErrorMessage} from "../../helpers/Utils";
import {Toast} from "../../components/common/Toast";
import BranchProductService from "../../services/branch_product/BranchProductService";
export const BranchProductContext = createContext("BranchProductContext");

const BranchProductContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [totalElements, setTotalElements] = useState(0);
    const [branchProductList, setBranchProductList] = useState([]);
    const [branchProductRelatedList, setBranchProductRelatedList] = useState([]);

    const [relatedProductLoading, setRelatedProductLoading] = useState(false);
    const [relatedProductList, setRelatedProductList] = useState([]);

    const getAllBranchProduct = async params => {
        try {

            setLoading(true);

            const res = await BranchProductService.getAllBranchProduct(params);
            setBranchProductList(res.data.content);
            setTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    const getAllBranchProductForRelatedProduct = async params => {
        try {

            setLoading(true);

            const res = await BranchProductService.getAllBranchProduct(params);
            setBranchProductRelatedList(res.data.content);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    const getAllRelatedProduct = async id => {
        try {

            setRelatedProductLoading(true);

            const res = await BranchProductService.getAllRelatedProduct(id);
            setRelatedProductList(res.data);

            setRelatedProductLoading(false);

            return res?.data;

        } catch (error) {

            setRelatedProductLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

            return [];

        }
    }

    const getLoadMoreBranchProducts = async params => {
        try {

            setLoading(true);

            const res = await BranchProductService.getAllBranchProduct(params);

            setBranchProductList([...branchProductList, ...res.data.content]);
            setTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    return (
        <BranchProductContext.Provider
            value={{
                loading,
                relatedProductLoading,
                totalElements,
                branchProductList,
                branchProductRelatedList,
                relatedProductList,
                getAllBranchProduct,
                getAllRelatedProduct,
                getAllBranchProductForRelatedProduct,
                getLoadMoreBranchProducts,
            }}
        >
            {children}
        </BranchProductContext.Provider>
    );
}

export default BranchProductContextProvider;
